import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import GoalItem from '../GoalListItem/GoalItem'
import './Page7-goal-science.css'

const Page7 = () => {
  const { goalsItems, mainGoal, isNoGoals } = useSelectReportData()

  if (isNoGoals) {
    return null
  }

  const mainGoalScienceTitle = mainGoal?.title || ''
  const mainGoalScienceText = mainGoal?.science_description_title || ''

  return (
    <div style={{ padding: '30px 23px 40px 23px' }}>
      <p className={'title-bold'}>Your goal</p>
      <p className={'description-sub'}>
        Throughout the program, you shared your unique goals, needs and preferences - thank you! Below you will find how glucose and lifestyle aspects can impact on your goals.
      </p>
      {goalsItems.map((directionItem, key) => {
        return (
          <GoalItem
            dark={false}
            {...directionItem}
            key={key}
          />
        )
      })}
      <p
        className={'subtitle'}
        style={{ marginTop: 25 }}
      >
        {mainGoalScienceTitle}
      </p>
      <p
        dangerouslySetInnerHTML={{ __html: mainGoalScienceText }}
        className={'description-sub'}
      ></p>
    </div>
  )
}

export default Page7
